'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "HeaderShownContext", {
    enumerable: true,
    get: function() {
        return HeaderShownContext;
    }
});
const _getNamedContext = require("../getNamedContext");
const HeaderShownContext = (0, _getNamedContext.getNamedContext)('HeaderShownContext', false);

//# sourceMappingURL=HeaderShownContext.js.map
